import { useStripePaymentContext } from '@/view/providers/StripePaymentProvider'
import { PaymentIntentData, SetupIntentData } from '@/@types/stripe'

export const useStripePayment = () => {
  const context = useStripePaymentContext()

  const chargeCustomer = async (paymentData: PaymentIntentData) => {
    await context.openPaymentDrawer(paymentData)
  }

  const setupPaymentMethod = async (setupData: SetupIntentData) => {
    await context.openSetupDrawer(setupData)
  }

  return {
    chargeCustomer,
    setupPaymentMethod,
    isProcessing: context.isProcessing,
    error: context.error,
    closePayment: context.closeDrawer,
  }
}
